/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/util/isPromise.js
// module id = ./node_modules/rxjs/_esm5/util/isPromise.js
// module chunks = vendor